
  <div class="relative w-full px-2 py-1 transition-colors duration-300 bg-gray-100 border-2 border-gray-400 rounded-xl"
  [class.bg-red]="readOnly"
  [class.border-solid]="readOnly"
  [class.border-dashed]="!readOnly"
  [class.border-green-500]="dragOver()"
    [class.border-gray-400]="!dragOver()"
    [class.shadow-lg]="dragOver()"
    [class.animate-pulse]="dragOver()">
 
  <div *ngIf="dragOver()" class="absolute inset-0 flex items-center pointer-events-none">
    <div class="text-5xl text-green-500 animate-bounce">📂</div>
  </div>

  <div *ngIf="readOnly && fileEntries.length === 0" class="px-4 py-2 italic text-gray-400">
    none.
  </div>
  <div *ngIf="!readOnly" class="pt-2">
    Drag & drop file here or use the file selection dialog.
    <input type="file" #fileInput hidden (change)="onFileInputChange($event)" accept=".pdf,image/*" multiple>
    <p-button label="Upload File" icon="pi pi-upload" (click)="fileInput.click()"></p-button>

</div>

<table *ngIf="fileEntries.length > 0" class="w-full my-3 text-sm border border-gray-300 table-auto">
  <thead class="bg-gray-100">
    <tr>
      <th class="px-2 py-1 text-left border-b border-gray-300">Name</th>
      <th class="px-2 py-1 text-left border-b border-gray-300">Size (KB)</th>
      <th class="px-2 py-1 text-left border-b border-gray-300">Date added</th>
      <th class="px-2 py-1 text-left border-b border-gray-300">Status</th>
      <th class="px-2 py-1 text-left border-b border-gray-300"></th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let file of fileEntries">
      <tr *ngIf="file.status !== 'deleted'" class="hover:bg-gray-50">
        <td class="px-2 py-1 border-b border-gray-200">
          <button
            *ngIf="readOnly"
            type="button"
            class="text-blue-700 underline hover:text-blue-900"
            (click)="downloadFile(file)">
            {{ file.name }}
          </button>
          <span *ngIf="!readOnly">{{ file.name }}</span>
        </td>
        <td class="px-2 py-1 border-b border-gray-200">{{ file.size ? formatFileSize(file.size) : '' }}</td>
        <td class="px-2 py-1 border-b border-gray-200">{{ file.addedAt ? (file.addedAt | date:'short') : '' }}</td>
        <td class="px-2 py-1 border-b border-gray-200">
          <span *ngIf="file.isValid && file.status =='saved'" class="text-green-600">{{ file.status }}</span>
          <span *ngIf="file.isValid && file.status !=='saved'" class="font-bold text-orange-400">{{ file.status }}</span>
          <span *ngIf="!file.isValid" class="font-bold text-red-600">{{ file.errorMessage }}</span>
        </td>
        <td class="px-2 py-1 text-red-600 border-b border-gray-200">
          <p-menu #menu [model]="fileMenuItems" [popup]="true" popupAlignment="bottom-start" appendTo="body" class="z-menu ml-4 text-xl mt-8" />
          <a class="hover:text-[var(--colorRed)] cursor-pointer"
             (click)="showFileMenu($event, menu, file)">
            <i class="pi pi-ellipsis-v"></i>
          </a>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<p-dialog header="Rename file" class="z-dialog" appendTo="body"
          [(visible)]="showRenameDialog"
          [modal]="false"
          [closable]="true"
          [style]="{width: '350px'}"
          (onHide)="closeRename()"
>
  <div class="mb-4">
    <label for="newName" class="block mb-2 text-sm font-medium text-gray-700">New file name:</label>
    <input id="newName"
           type="text"
           [(ngModel)]="newFileName"
           class="w-full p-inputtext p-component"
           autocomplete="off"
    />
  </div>
  <div *ngIf="renameErrorMsg" class="mt-1 text-sm text-red-600">
    {{ renameErrorMsg }}
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancel" class="p-button-text" (click)="closeRename()"></button>
    <button pButton type="button" label="Okay" class="p-button-primary" (click)="confirmRename()" [disabled]="!newFileName.trim()"></button>
  </ng-template>
</p-dialog>


<div class="mt-2 text-red-600" *ngIf="errorMsg">{{ errorMsg }}</div>



